import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { UsersTable } from 'components/data/UsersTable/UsersTable'
import { useGetUsersFromOwnCompany } from 'api/queries/users/users'
import { UserListItemType } from 'components/data/UserList/UserListItem/UserListItem'
import { useRegisterOwnCompanyMemberMutation } from 'api/mutations/users/users'

interface CompanyUsersScreenLocation {
  newUser: boolean
}

const CompanyUsersScreen: React.FC = () => {
  const { i18n } = useTranslation()
  const location = useLocation<CompanyUsersScreenLocation>()

  const languageCode = useMemo(() => i18n.languages[0], [i18n])

  const {
    data,
    isLoading,
    isError,
  } = useGetUsersFromOwnCompany()

  const users = useMemo(() => (data || []), [data])

  const { mutateAsync } = useRegisterOwnCompanyMemberMutation()

  const handleRegister = async (user: UserListItemType) => {
    await mutateAsync({
      user: {
        languageCode,
        timeZone: user.timeZone ? user.timeZone : 'UTC',
        ...user
      },
      id: 0
    })
  }

  return (
    <UsersTable
      usersData={users}
      isDataError={isError}
      isDataLoading={isLoading}
      userQueryKey='ownCompanyUsers'
      onRegister={handleRegister}
      newUserVisible={location.state?.newUser}
    />
  )
}

export { CompanyUsersScreen }
